import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  novelStyle: {
    fontFamily: 'serif',
    fontSize: 18,
    color: '#fff',
    background: '#1a1a1a',
  },
};

const settingSlice = createSlice({
  name: 'setting',
  initialState,
  reducers: {
    setNovelStyle(state, action) {
      state.novelStyle = action.payload;
    },
  },
});

export const { setNovelStyle } = settingSlice.actions;
export default settingSlice.reducer;
